import React from "react";
import { Route, Routes } from "react-router-dom";
import { allRoutes, authRoutes, pagesRoutes } from "./allRoutes";
import NonAuthLayout from "../Layout/NonAuthLayout";
import Authmiddleware from "./Authmiddleware";
import Layout from "../Layout/Index";
import PagesLayout from "../Layout/PagesLayout";

const Routing = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {authRoutes.map((route : any, idx : any) => (
            <Route
              key={idx}
              path={route.path}
              element={<NonAuthLayout> {route.component} </NonAuthLayout>}
            />
          ))}
        </Route>
        <Route>
          {pagesRoutes.map((route : any, idx : any) => (
            <Route
              key={idx}
              path={route.path}
              element={<PagesLayout> {route.component} </PagesLayout>}
            />
          ))}
        </Route>
        <Route>
          {allRoutes.map((route : any, idx : any) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <Authmiddleware>
                  <Layout>{route.component}</Layout>
                </Authmiddleware>
              }
              // exact={true}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Routing;
